import { MenuItem, MenuRadioGroup, SubMenu } from '@szhsin/react-menu';

import React from 'react';
import { SettingsContext } from '../../../context/context';
import { useContext } from 'react';

const PageOrientation = () => {
  const { state, dispatch } = useContext(SettingsContext);
  return (
    <SubMenu label="Orientation">
      <MenuRadioGroup
        value={state.pageOrientation}
        onRadioChange={e => dispatch({type: 'pageOrientation', payload: e.value})}>
        <MenuItem type="radio" value="">Letter</MenuItem>
        <MenuItem type="radio" value="landscape">Landscape</MenuItem>
      </MenuRadioGroup>
    </SubMenu>
  );
};

export default PageOrientation;
